// extracted by mini-css-extract-plugin
export var Box = "styles-module--Box--e757f";
export var Hamburger = "styles-module--Hamburger--040a0";
export var Inner = "styles-module--Inner--533fa";
export var Menu = "styles-module--Menu--730b8";
export var Squeeze = "styles-module--Squeeze--53766";